'use client';

import TextArea from '../../../atoms/TextArea/TextArea';
import { getValidationResponse } from '../utils';
import type { TextAreaField } from '../types';
import type { UseFormRegister, FieldValues, FieldErrors } from 'react-hook-form';

export type TextAreaControlProps = {
  field: TextAreaField;
  theme: 'dark' | 'light';
  direction: 'ltr' | 'rtl';
  register: UseFormRegister<FieldValues>;
  errors: FieldErrors<FieldValues>;
};

/**
 * Form control for textarea fields
 * @component
 * @param {TextAreaControlProps} props - Component props
 * @returns {JSX.Element} TextArea control component
 */
const TextAreaControl = ({ field, theme, direction, register, errors }: TextAreaControlProps) => {
  return (
    <TextArea
      theme={theme}
      key={`form_field_${field.name}`}
      name={field.name}
      label={field.label}
      helperText={field.helperText}
      placeholder={field.placeholder}
      required={field.required}
      rows={field.rows}
      maxLength={field.maxLength}
      showCharCount={field.showCharCount}
      resize={field.resize}
      onChange={field.onChange}
      controlled={!!field.controlled}
      register={() =>
        register(field.name, {
          required: field.required ? field?.validationMessages?.required : false,
          validate: field?.validate || undefined,
        })
      }
      validationResponse={getValidationResponse({ field: field.name, errors })}
      direction={direction}
    />
  );
};

export default TextAreaControl;
